// src/AdminPanel.js
import React, { useState, useEffect } from "react";
import { collection, onSnapshot, updateDoc, deleteDoc, doc } from "firebase/firestore";
import { ref, deleteObject } from "firebase/storage";
import { db, storage } from "./firebase";

const statuses = ["pending", "processing", "completed", "canceled"];
const DEFAULT_LITHO_IMAGE_URL = process.env.PUBLIC_URL + "/default-litho-image.png";
const ADMIN_PASSWORD = "123";

const AdminPanel = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [adminPassword, setAdminPassword] = useState("");
  const [orders, setOrders] = useState([]);
  const [filterStatus, setFilterStatus] = useState("");

  useEffect(() => {
    if (isAuthenticated) {
      const unsubscribe = onSnapshot(
        collection(db, "orders"),
        (snapshot) => {
          const ordersData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setOrders(ordersData);
        },
        (error) => {
          console.error("Error fetching orders:", error);
        }
      );
      return () => unsubscribe();
    }
  }, [isAuthenticated]);

  const handleStatusChange = async (orderId, newStatus) => {
    try {
      const orderDocRef = doc(db, "orders", orderId);
      await updateDoc(orderDocRef, { orderStatus: newStatus });
    } catch (error) {
      console.error("Error updating order status:", error);
      alert("There was an error updating the order status.");
    }
  };

  const handleDeleteOrder = async (order) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this order? This will remove the order and its photo from Firebase."
    );
    if (!confirmed) return;
    try {
      if (order.fileURL && order.fileURL !== DEFAULT_LITHO_IMAGE_URL) {
        const filePathEncodedMatch = order.fileURL.match(/\/o\/(.*?)\?/);
        if (filePathEncodedMatch && filePathEncodedMatch[1]) {
          const filePath = decodeURIComponent(filePathEncodedMatch[1]);
          const fileRef = ref(storage, filePath);
          await deleteObject(fileRef);
        } else {
          console.warn("Could not extract file path from URL:", order.fileURL);
        }
      }
      await deleteDoc(doc(db, "orders", order.id));
      alert("Order deleted successfully.");
    } catch (error) {
      console.error("Error deleting order:", error);
      alert("There was an error deleting the order. Please try again.");
    }
  };

  const filteredOrders = filterStatus
    ? orders.filter((order) => (order.orderStatus || "pending") === filterStatus)
    : orders;

  if (!isAuthenticated) {
    return (
      <div style={{ padding: "20px" }}>
        <h2>Admin Login</h2>
        <input
          type="password"
          placeholder="Enter admin password"
          value={adminPassword}
          onChange={(e) => setAdminPassword(e.target.value)}
          style={{ marginRight: "8px", padding: "6px" }}
        />
        <button onClick={() => {
          if (adminPassword === ADMIN_PASSWORD) setIsAuthenticated(true);
          else { alert("Incorrect password. Please try again."); setAdminPassword(""); }
        }}>
          Login
        </button>
      </div>
    );
  }

  return (
    <div style={{ padding: "20px", maxWidth: "1000px", margin: "0 auto" }}>
      <h2>Admin Panel: Manage Orders</h2>
      <div style={{ marginBottom: "20px" }}>
        <label htmlFor="statusFilter" style={{ marginRight: "8px" }}>Filter by Status:</label>
        <select
          id="statusFilter"
          value={filterStatus}
          onChange={(e) => setFilterStatus(e.target.value)}
        >
          <option value="">All</option>
          {statuses.map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
      </div>
      <table style={{ width: "100%", borderCollapse: "collapse" }} border="1" cellPadding="8" cellSpacing="0">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Phone</th>
            <th>Address</th>
            <th>Color Option</th>
            <th>Frame Color</th>
            <th>Status</th>
            <th>Location</th>
            <th>Photo</th>
            <th>Created At</th>
            <th>Update Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredOrders.map((order) => {
            const createdAt = order.createdAt?.toDate
              ? order.createdAt.toDate().toLocaleString()
              : order.createdAt || "N/A";
            const locationDisplay = order.location
              ? `Lat: ${order.location.lat}, Lng: ${order.location.lng}`
              : "N/A";
            return (
              <tr key={order.id}>
                <td>{order.id}</td>
                <td>{order.name}</td>
                <td>{order.phone}</td>
                <td>{order.address}</td>
                <td>{order.colorOption}</td>
                <td>{order.frameColor}</td>
                <td>{order.orderStatus || "pending"}</td>
                <td>
                  {order.location ? (
                    <a
                      href={`https://www.google.com/maps?q=${order.location.lat},${order.location.lng}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {locationDisplay}
                    </a>
                  ) : (
                    "N/A"
                  )}
                </td>
                <td>
                  {order.fileURL && order.fileURL !== DEFAULT_LITHO_IMAGE_URL ? (
                    <a href={order.fileURL} target="_blank" rel="noopener noreferrer" download>
                      <img src={order.fileURL} alt="Download" style={{ width: "100px", cursor: "pointer" }} />
                    </a>
                  ) : (
                    "N/A"
                  )}
                </td>
                <td>{createdAt}</td>
                <td>
                  <select value={order.orderStatus || "pending"} onChange={(e) => handleStatusChange(order.id, e.target.value)}>
                    {statuses.map((s) => (
                      <option key={s} value={s}>{s}</option>
                    ))}
                  </select>
                </td>
                <td>
                  <button onClick={() => handleDeleteOrder(order)} style={{ color: "red" }}>
                    Delete
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {filteredOrders.length === 0 && <p>No orders found.</p>}
    </div>
  );
};

export default AdminPanel;
